module.exports = __webpack_public_path__ + "img/рз_28.24302448.png";